<mat-toolbar class="toolbar-sticky" *ngIf="isOperator | async as isOperator">
  <mat-toolbar-row>
    <button mat-button class="sidenav-toggle" (click)="toggleSidenav.emit()">
      <mat-icon class="icon-header-color">menu</mat-icon>
    </button>
    <span class="spacer"></span>
   {{roles}} 
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon class="icon-header-color">account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
     
          <mat-icon class="icon-header-color">account_circle</mat-icon> 
          <strong>{{username}}</strong>
          <br /> {{email}}  
      <br />
     
      </button>
      <button mat-menu-item  (click)="changeTheme()">
        <mat-icon>brightness_6</mat-icon>
        <span>Change Theme</span>
      </button>
      <button mat-menu-item  (click)="changePassword()">
        <mat-icon>lock</mat-icon>
        <span>Change Password</span>
      </button>
      <button mat-menu-item  (click)="onLogout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
 